import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { dateConverter } from "../../../../../utils/dateConverter";
import SingleClient from "../../../../clients/components/SingleClient";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import SingleOrganization from "../../../../organization/components/SingleOrganization";
import { SingleStation } from "../../../../stations/components/SingleStation";
import SingleUser from "../../../../user/components/SingleUser";
import { useSinglePaygo } from "../../../hooks/usePaygo";
import PayGoGenericView from "./PayGoGenericView/PayGoGenericView";

export default function PayGoGenericInfo() {
  const {
    singlePaygoQuery: { isLoading, isError, error, data },
  } = useSinglePaygo();

  const navigationApp = useNavigationApp();
  if (isLoading) {
    return <LoaderSreen heigth={"200px"} />;
  }

  if (isError) {
    return <ErrorScreenApp axiosError={error} />;
  }



  return (
    <PayGoGenericView
      stationNameRender={() => (
        <SingleStation.Name idStation={data?.paygo_station} />
      )}
      onClickPayGoOriginal={
        data?.paygo_parent && data?.paygo_parent !== ""?
        () => {
        navigationApp.goToSinglePayGo(data?.paygo_parent);
      }: undefined}
      createdAt={dateConverter(data?.paygo_created_at, { withTime: true })}
      description={data?.paygo_description}
      userNameForRender={
        data?.paygo_client || data?.paygo_client_phone_number
          ? () => (
              <>
                <SingleClient.Info
                  info={"client_firstname"}
                  id={data?.paygo_client}
               
                />{" "}
                <SingleClient.Info
                  info={"client_lastname"}
                  id={data?.paygo_client}
                />{" "}
                
                - {data?.paygo_client_phone_number}{" "}
              </>
            )
          : undefined
      }
      organizationNameRender={
        data?.organization_id && data?.organization_id !== ""
          ? () => (
              <SingleOrganization.Name organizationId={data?.organization_id} />
            )
          : undefined
      }
      onClickStation={() =>
        navigationApp.goToSingleStation(data?.paygo_station)
      }
      onClickOrganization={
        data?.organization_id && data?.organization_id !== ""
          ? () => navigationApp.goToSingleOrganization(data?.organization_id)
          : undefined
      }
      createdWith={() => <>{data?.paygo_parent}</>}
      connecterNameRender={
        data?.paygo_connector_slug
          ? () => <>{data.paygo_connector_slug}</>
          : undefined
      }
      createdByRender={
        data?.paygo_created_by_user
          ? () => (
              <>
                <SingleUser.UserExtendInfo
                  userOrgaId={data.paygo_created_by_user}
                  info="user_firstname"
                />{" "}
                <SingleUser.UserExtendInfo
                  userOrgaId={data.paygo_created_by_user}
                  info="user_lastname"
                />
              </>
            )
          : undefined
      }
      pricePerKWh={data?.paygo_price_by_kwh}
      currency={data?.paygo_currency || "FCFA -"}
      paygoType={data?.paygo_type}
    />
  );
}
